import React, { useEffect, useState } from 'react';
import { Route, Switch, useLocation } from 'react-router';
import { Layout, Menu, Breadcrumb } from 'antd';
import User from './User/User';
import Space from './Spaces/Space';
import {
  DesktopOutlined,
  PieChartOutlined,
  FileOutlined,
  TeamOutlined,
  UserOutlined,
  PicLeftOutlined,
  StarOutlined,
  LogoutOutlined,
  HistoryOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import { setState } from 'expect/build/jestMatchersObject';
import { useCookies } from 'react-cookie';
import Interceptor from '../Interceptor';
import SpaceEdit from './Spaces/SpaceEdit/SpaceEdit';
import PicksOfTheWeek from './PickOfTheWeek/PicksOfTheWeek';
import NewsLetter from './NewsLetter/NewsLetter';
import Host from './CreateHost/CreateHost';
import logo from '../../assets/images/home/ms-white-logo.svg';
import NewHostOnboarding from './NewHostOnboarding/NewHostOnboarding';
import NewHostOnboardingDetails from './NewHostOnboarding/NewHostOnboardingDetails/NewHostOnboardingDetails';
import PromoCodeUsage from './promoCodeUsage/ShowPromoCodeUage';
import { getCountryCode } from './NewHostOnboarding/NewHostOnboardingAction';
import { useDispatch } from 'react-redux';
import SpaceReview from './SpaceReview/SpaceReview';
import CreateAdmin from './CreateAdmin/CreateAdmin';
import CreatePromoCode from './CreatePromoCode/CreatePromoCode';
import AddSuperDeal from './SuperDeals/AddSuperDeal';
import ListUserReviews from './UserReviews/ListUserReviews/ListUserReviews';
import OfflineBooking from './OfflineBooking/OfflineBooking';
import OfflineBookingListPage from './OfflineBooking/OfflineBookingListPage';
import ViewOfflineBooking from './OfflineBooking/ViewOfflineBooking';
import AuditTrackingPage from './AuditTracking/AuditTrackingPage';
import BlogList from './BlogPost/BlogList';
import BlogForm from './BlogPost/BlogForm';
import BlogView from './BlogPost/BlogView';

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

const Dashboard = ({ history }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [collapsed, setCollapsed] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(['token']);
  const [selectedKey, setSelectedKey] = useState('');

  const handleItemClick = (path) => {
    history.push(`/dashboard/${path}`);
  };

  useEffect(() => {
    const path = location.pathname.split('/dashboard/')[1] || '';

    const routeMapping = {
      'space/add': '1',
      'space/list': '2',
      'space/edit': '2',
      'promotion/add': '3',
      newsletter: '4',
      'host/add': '5',
      'space/assignspace': '6',
      'newHostOnboarding/hosts': '7',
      'space/review': '8',
      userReviews: '9',
      promoCodeUsage: '10',
      promoCodeCreate: '11',
      'admin/assign': '12',
      addSuperDeal: '13',
      'booking/offline': '14',
      'offline-booking-list': '14',
      'offline-booking/view': '14',
      'audit-tracking': '15',
      'blog-posts': '16',
      'blog-posts/create': '16',
      'blog-posts/edit': '16',
      'blog-posts/view': '16',
    };

    let matchedKey = '2';
    for (const [route, key] of Object.entries(routeMapping)) {
      if (path.startsWith(route)) {
        matchedKey = key;
        break;
      }
    }

    setSelectedKey(matchedKey);
  }, [location.pathname]);

  useEffect(() => {
    dispatch(getCountryCode());
  }, []);
  const onCollapse = (collapsed) => {
    setCollapsed(collapsed);
  };

  const signOut = () => {
    removeCookie('token', { path: '/' });
    history.push(`/`);
  };

  return (
    <>
      <Interceptor />
      <Layout className="admin-panel-left-menu">
        {' '}
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={onCollapse}
          style={{
            overflow: 'hidden',
            height: '100vh',
            position: 'fixed',
            left: 0,
            top: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            zIndex: 10,
          }}
        >
          <div style={{ padding: '16px', textAlign: 'center', flexShrink: 0 }}>
            <img
              src={logo}
              alt="logo"
              className="img-logo white-logo"
              style={{ maxWidth: '100%' }}
            />
          </div>
          <div
            className="sider-scroll-wrapper"
            style={{
              flex: '1',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
            }}
          >
            <Menu
              theme="dark"
              // defaultSelectedKeys={['2']}
              selectedKeys={[selectedKey]}
              mode="inline"
              style={{ flex: 1, height: '100%', border: 'none' }}
            >
              <Menu.Item key="1" onClick={(e) => handleItemClick('space/add')}>
                <PieChartOutlined />
                <span>Add Space</span>
              </Menu.Item>
              <Menu.Item key="2" onClick={(e) => handleItemClick('space/list')}>
                <DesktopOutlined />
                <span>Space List</span>
              </Menu.Item>
              <Menu.Item key="3" onClick={(e) => handleItemClick('promotion/add')}>
                <DesktopOutlined />
                <span>Picks of the Week</span>
              </Menu.Item>
              <Menu.Item key="4" onClick={(e) => handleItemClick('newsletter')}>
                <PicLeftOutlined />
                <span>Newsletter</span>
              </Menu.Item>
              <Menu.Item key="5" onClick={(e) => handleItemClick('host/add')}>
                <DesktopOutlined />
                <span>Create Host</span>
              </Menu.Item>
              <Menu.Item key="6" onClick={(e) => handleItemClick('space/assignspace')}>
                <DesktopOutlined />
                <span>Assign Space</span>
              </Menu.Item>
              <Menu.Item key="7" onClick={(e) => handleItemClick('newHostOnboarding/hosts')}>
                <TeamOutlined />
                <span>Host Onboarding</span>
              </Menu.Item>
              <Menu.Item key="8" onClick={(e) => handleItemClick('space/review')}>
                <StarOutlined />
                <span>Space Reviews</span>
              </Menu.Item>
              <Menu.Item key="9" onClick={(e) => handleItemClick('userReviews')}>
                <StarOutlined />
                <span>User Reviews</span>
              </Menu.Item>
              <Menu.Item key="10" onClick={(e) => handleItemClick('promoCodeUsage')}>
                <StarOutlined />
                <span>Promo Code Usage</span>
              </Menu.Item>

              <Menu.Item key="11" onClick={(e) => handleItemClick('promoCodeCreate')}>
                <StarOutlined />
                <span>Promo Code Create</span>
              </Menu.Item>
              <Menu.Item key="12" onClick={(e) => handleItemClick('admin/assign')}>
                <UserOutlined />
                <span>Create Admin</span>
              </Menu.Item>
              <Menu.Item key="13" onClick={(e) => handleItemClick('addSuperDeal')}>
                <UserOutlined />
                <span>Add Super Deal</span>
              </Menu.Item>
              <Menu.Item key="14" onClick={(e) => handleItemClick('booking/offline')}>
                <FileOutlined />
                <span>Offline Booking</span>
              </Menu.Item>
              <Menu.Item key="15" onClick={(e) => handleItemClick('audit-tracking')}>
                <HistoryOutlined />
                <span>Audit & Tracking</span>
              </Menu.Item>
              <Menu.Item key="16" onClick={(e) => handleItemClick('blog-posts')}>
                <FileTextOutlined />
                <span>Blog Posts</span>
              </Menu.Item>
              {/*<SubMenu*/}
              {/*  key="sub1"*/}
              {/*  title={*/}
              {/*    <span>*/}
              {/*      <UserOutlined />*/}
              {/*      <span>User</span>*/}
              {/*    </span>*/}
              {/*  }*/}
              {/*>*/}
              {/*  <Menu.Item key="4">Tom</Menu.Item>*/}
              {/*  <Menu.Item key="5">Bill</Menu.Item>*/}
              {/*  <Menu.Item key="6">Alex</Menu.Item>*/}
              {/*</SubMenu>*/}
              {/*<SubMenu*/}
              {/*  key="sub2"*/}
              {/*  title={*/}
              {/*    <span>*/}
              {/*      <TeamOutlined />*/}
              {/*      <span>Team</span>*/}
              {/*    </span>*/}
              {/*  }*/}
              {/*>*/}
              {/*  <Menu.Item key="7">Team 1</Menu.Item>*/}
              {/*  <Menu.Item key="8">Team 2</Menu.Item>*/}
              {/*</SubMenu>*/}
              {/*<Menu.Item key="9">*/}
              {/*  <FileOutlined />*/}
              {/*</Menu.Item>*/}
            </Menu>{' '}
          </div>
          <div
            className="log-out-btn-wrapper"
            onClick={signOut}
            style={{
              padding: '16px',
              textAlign: 'center',
              borderTop: '1px solid rgba(255, 255, 255, 0.2)',
              marginTop: 'auto',
            }}
          >
            <button
              className="lg-out btn-yellow"
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <LogoutOutlined style={{ marginRight: collapsed ? 0 : 8 }} />
              {!collapsed && <span>Logout</span>}
            </button>
          </div>
        </Sider>
        <Layout
          className="site-layout"
          style={{
            marginLeft: collapsed ? 80 : 200,
            transition: 'margin-left 0.2s',
          }}
        >
          <Header
            className="site-layout-background"
            style={{ padding: 0, position: 'sticky', top: 0, zIndex: 1 }}
          />{' '}
          <Content style={{ margin: '0 16px', overflow: 'auto', position: 'relative' }}>
            <Switch>
              <Route path={'/dashboard/space/add'} component={SpaceEdit} />
              <Route path={'/dashboard/space/list'} component={Space} />
              <Route path={'/dashboard/space/review'} component={SpaceReview} />
              <Route path={'/dashboard/promotion/add'} component={PicksOfTheWeek} />
              <Route path={'/dashboard/newsletter'} component={NewsLetter} />
              <Route path={'/dashboard/host/add'} component={Host} />
              <Route path={'/dashboard/admin/assign'} component={CreateAdmin} />
              <Route path={'/dashboard/newHostOnboarding/hosts'} component={NewHostOnboarding} />
              <Route
                path={'/dashboard/newHostOnboarding/details'}
                component={NewHostOnboardingDetails}
              />
              <Route path={'/dashboard/promoCodeUsage'} component={PromoCodeUsage} />

              <Route path={'/dashboard/promoCodeCreate'} component={CreatePromoCode} />
              <Route path={'/dashboard/addSuperDeal'} component={AddSuperDeal} />
              <Route path={'/dashboard/userReviews'} component={ListUserReviews} />
              <Route path={'/dashboard/booking/offline'} component={OfflineBooking} />
              <Route path={'/dashboard/offline-booking-list'} component={OfflineBookingListPage} />
              <Route path={'/dashboard/offline-booking/view/:id'} component={ViewOfflineBooking} />
              <Route path={'/dashboard/audit-tracking'} component={AuditTrackingPage} />
              <Route exact path={'/dashboard/blog-posts'} component={BlogList} />
              <Route exact path={'/dashboard/blog-posts/create'} component={BlogForm} />
              <Route exact path={'/dashboard/blog-posts/edit/:id'} component={BlogForm} />
              <Route exact path={'/dashboard/blog-posts/view/:id'} component={BlogView} />
              <Route path={'*'} component={Space} />
            </Switch>
          </Content>
          <Footer style={{ textAlign: 'center' }}>Ant Design ©2018 Created by Ant UED</Footer>
        </Layout>
      </Layout>
    </>
  );
};

export default Dashboard;
